import { Component, OnDestroy } from '@angular/core';
import { OrderInboxService } from '../service/order-inbox.service';
import { INBOX_GLOBAL_FILTER } from '../model/inbox-global-filters';
import { take, tap } from 'rxjs/operators';
import { InboxStateModel } from '../state/model/inbox-state.model';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';

@Component({
	selector: 'cv-inbox-header',
	templateUrl: './inbox-header.component.html',
	styleUrls: ['./inbox-header.component.scss']
})
export class InboxHeaderComponent implements OnDestroy {
	inboxStateModel$: Observable<InboxStateModel> = this.store.select(state => state.intelligence.inbox);
	globalFilterOptions: Array<any>;
	defaultGlobalFilter: any;

	constructor(
		private orderInboxService: OrderInboxService,
		private store: Store
	) {
		this.defaultGlobalFilter = null;
		this.globalFilterOptions = [
			INBOX_GLOBAL_FILTER.READY_FOR_REVIEW,
			INBOX_GLOBAL_FILTER.REVISIONS,
			INBOX_GLOBAL_FILTER.INNOVATION_REVIEW,
			INBOX_GLOBAL_FILTER.INNOVATION_REVISION
		];
		this.inboxStateModel$
			.pipe(
				take(1),
				tap((inboxStateModel: InboxStateModel) => {
					if (inboxStateModel && inboxStateModel.inboxFilterForm && inboxStateModel.inboxFilterForm.inboxGlobalFilter) {
						this.defaultGlobalFilter = {...inboxStateModel.inboxFilterForm.inboxGlobalFilter};
					}
				})
			)
			.subscribe();
	}

	/**
	 * Calls service to communicate with Inbox component to reload the grid.
	 */
	reloadInbox(): void {
		this.orderInboxService.setHeaderInboxData({reloadInbox: true});
	}

	/**
	 * onGlobalFilterChange Handler.
	 * @param $event: any
	 */
	onGlobalFilterChange($event: any): void {
		this.orderInboxService.setHeaderInboxData({applyGlobalFilters: $event || {}});
	}

	ngOnDestroy(): void {
		this.orderInboxService.setHeaderInboxData({});
	}
}
